import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from './../shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { STATISTICS_ROUTES } from './statistics.routes';
import { StatisticsComponent } from './statistics.component';
import { StatisticsCustomersComponent } from './statistics-customers/statistics-customers.component';
import { StatisticsEventsComponent } from './statistics-events/statistics-events.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(STATISTICS_ROUTES),
    SharedModule,
    NgSelectModule
  ],
  declarations: [
    StatisticsComponent,
    StatisticsCustomersComponent,
    StatisticsEventsComponent
  ],
  providers: [
  ]
})
export class StatisticsModule { }
